import React from "react";

/**
 * Logo <img> do Linkia (cérebro/chat verde).
 * Usa arquivo servido direto pelo frontend em /logo.png
 * (mesmo arquivo está em /app/backend/assets/logo.png).
 */
export default function Logo({ className = "w-6 h-6", alt = "Linkia" }) {
    return (
        <img
            src="/logo.png"
            alt={alt}
            draggable={false}
            className={`${className} object-contain select-none`}
        />
    );
}
